<script>
import { format } from 'date-fns'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: String,
      default: '',
    },
    maxDate: {
      type: String,
      default: '',
    },
    errorMessages: {
      type: [String, Array],
      default: '',
    },
  },

  data() {
    return {
      menu: false,
    }
  },

  computed: {
    date: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    formatedDate() {
      if (!this.date) return this.date
      return format(this.date, 'D MMM YYYY')
    },
  },
}
</script>

<template>
  <VMenu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="slide-y-transition"
    min-width="290px"
    lazy
    offset-y
    full-width
  >
    <VTextField
      slot="activator"
      v-model="formatedDate"
      :label="label"
      :color="color"
      :prepend-icon="hasIcon ? 'event' : ''"
      :error-messages="errorMessages"
      readonly
    />

    <VDatePicker
      v-model="date"
      :min="minDate"
      :max="maxDate"
      :color="color"
      @input="$refs.menu.save(date)"
    />
  </VMenu>
</template>
